import React, { useEffect, useState } from 'react'
import Logo from '../OnboardingRevampPage/Logo'
import { ClipLoader, PulseLoader } from 'react-spinners'
import { useDispatch, useSelector } from 'react-redux'
import { fetchQuestions } from '../../redux/actions/personaliseCourse'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck } from '@fortawesome/free-solid-svg-icons'
import Slider from 'react-slick'
import useWindowSize from '../../hooks/useWindowSize'
import { useNavigate } from 'react-router-dom'
import { Mixpanel } from "../../config/Mixpanel"
import Constants from '../../common/constants'
import { toast } from 'react-toastify'
import './index.css'

export const testimonials = [
    {
        id: 1,
        name: 'Vivek Jarngal',
        image: 'https://assets.learntube.ai/files/AI_Syllabus_generator/Ellipse_907.png?updatedAt=1685776843845',
        designation: 'Freelance Designer',
        description:`“This is exactly what I was looking for”`

    },
    {
        id: 2,
        name: 'Bala Nath Rai',
        image: 'https://assets.learntube.ai/files/AI_Syllabus_generator/Ellipse_907__1_.png?updatedAt=1685776939014',
        designation: 'Account Executive',
        description:`“Wow, I really didn’t know there was so much I needed to learn!”`

    },
    {
        id: 3,
        name: 'Shruti Das',
        image: 'https://assets.learntube.ai/files/AI_Syllabus_generator/Shruti.png?updatedAt=1685777697916',
        designation: 'Web Developer',
        description:`“Finally, a course that understands me & my goals!”`

    },
    {
        id: 4,
        name: 'Somesh Mishra',
        image: 'https://assets.learntube.ai/files/AI_Syllabus_generator/Ellipse_907__3_.png?updatedAt=1685777109765',
        designation: 'Project Manager',
        description:`“I’ve been looking since months when the perfect course was just minutes away..”`

    },
]

export const questionLoader = [
    {
        id: 1,
        description: 'Analysing the skill map'
    },
    {
        id: 2,
        description: 'Generating questions for you'
    },
    {
        id: 3,
        description: 'Loading questions and optimising quiz settings'
    },
    {
        id: 4,
        description: 'Loading questions and optimising quiz settings'
    },
]


const QuizLoader = () => {

    const userName = useSelector(store => store?.profileDetails?.name)
    const uid = useSelector(store => store?.personaliseCourse?.UUID)
    const skillDetails = useSelector(store => store?.personaliseCourse?.skillDetails)
    const skillName = useSelector(store => store?.personaliseCourse?.skill_name)
    const questions = useSelector(store => store?.personaliseCourse?.questions?.questionaire)
    const email = useSelector(store => store?.profileDetails?.email)

    const [ step, setStep ] = useState(1)
    const [index, setIndex] = useState(0)
    const [seconds, setSeconds] = useState(20)
    const [showTick1, setShowTick1] = useState(false)
    
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const { width } = useWindowSize()

    const settings = {
        dots: false,
        slidesToShow: width < 1400 ? 2.7 : 3,
        rows: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        easing: 'linear',
        cssEase: "linear",
        infinite: true,
        arrows: false,
        responsive: [
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    infinite: true,
                    dots: false,
                    arrows: false,
                    swipeToSlide: false,
                }
            },
        ]
    };
    
    useEffect(() => {
        Mixpanel.track(Constants.Mixpanel.PERSONALISE_PAGE_QUESTION_LOADER, {
            distinct_id: email
        })
        setTimeout(() => setStep(prev => prev + 1), 3000)
        dispatch(fetchQuestions(uid, skillName, skillDetails?.skill, res => {
            if (!Array.isArray(res.questionaire)) {
                toast.error("Something went wrong Please try again later")
                navigate('/onboarding')
            }
        }))
    }, [])

    useEffect(() => {
        if (questions?.length > 7){
            navigate('/onboarding/questions/1')
        }
    }, [questions, navigate])

    useEffect(() => {
        if (step === 2) {
            if (seconds > 0) {
            const timer = setTimeout(() => setSeconds(seconds - 1), 1000)
            return () => clearTimeout(timer)
        }}
    }, [seconds, step])

    useEffect(() => {
        if (step === 2){
            if (seconds === 17){
                setShowTick1(!showTick1)
            }
            if (seconds === 15){
                setIndex(index + 1)
                setShowTick1(!showTick1)
            }
            if (seconds === 12){
                setShowTick1(!showTick1)
            }
            if (seconds === 10){
                setIndex(index + 1)
                setShowTick1(!showTick1)
            }
            if (seconds === 7){
                setShowTick1(!showTick1)
            }
            if (seconds === 5){
                setIndex(index + 1)
                setShowTick1(!showTick1)
            }
            if (seconds === 2){
                setShowTick1(!showTick1)
            }
            if (seconds === 0){
                setIndex(0)
                setSeconds(20)
                setShowTick1(!showTick1)
            }
        }
    },[step, seconds])


    return (
        <div className='min-h-screen flex flex-col p-4 text-white parent-radial-background' >
            <Logo/>
            
            {step === 1 ? <div className='md:w-3/4 md:mx-auto flex flex-col items-center flex-1'>
                <div className='flex flex-col items-center mt-6 md:mt-0'>
                    <ClipLoader color='#1CB05E' size={25} className='mb-3 md:mb-1'/>
                    <div className='flex'>
                        <p className='text-sm'>Generating Questions</p>
                        <PulseLoader size={3} color='white' className='mt-2.5'/>
                    </div>
                </div>
                <div className='flex-1 flex flex-col mt-14 items-center text-center'>
                    <div className='w-[80%] md:w-[35%] h-full'>
                        <img src="https://assets.learntube.ai/files/Onboarding_Revamp/Group%209177.png?updatedAt=1694614328639" alt="trophy image" className='w-full h-auto'/>
                    </div>
                    <h2 className='text-2xl'>Awesome {userName?.split(" ")[0]}, Let’s <span className='font-semibold text-[#00C1FF]'>Personalise This Couse</span></h2>
                    <p className='font-medium'>Take a quiz to help us analysis your skills</p>
                </div>
            </div> :
            step === 2 ? <div className='md:w-4/5 md:mx-auto'>
                <div className='flex flex-col items-center'>
                    <ClipLoader color='#7FC241' size={30} />
                    <div className='flex justify-center'>
                        {showTick1 && <FontAwesomeIcon icon={faCheck} className='text-[#7FC241] text-xl mr-2 mt-1'/>}
                        <p className='text-sm mt-1'>{questionLoader[index].description}{showTick1 ? '!' : ''}</p>
                        {!showTick1 && <PulseLoader color='#fff' size={2} className='mt-4'/>}
                    </div>
                </div>
                <div className={`flex-1 flex text-center flex-col mt-20`}>
                    <h2 className='text-[2rem] leading-[37px]'><span className='text-[#00C1FF] font-bold'>Reactions </span> When Learners Saw Their Personalised Course</h2>
                    <div className='mt-5'>
                        <Slider {...settings}>
                            {testimonials?.map((item, index) => (
                                <div className={`h-[170px] md:max-w-[360px] mr-2 bg-[#2D4F71] rounded-[10px] p-3`}>
                                    <div className='h-full flex flex-col justify-center'>
                                        <p className='font-medium text-xl'>{item?.description}</p>
                                        <div className='flex items-center justify-center mt-3'>
                                            <div className='w-[40px] h-[40px] rounded-full'>
                                                <img src={item?.image} alt="user image" />
                                            </div>
                                            <div className='text-left leading-4 ml-3 flex flex-col justify-center'>
                                                <p className=''>{item?.name}</p>
                                                <p className='text-sm opacity-50'>{item?.designation}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </Slider>
                    </div>
                    <div className={`flex justify-center mt-5`}>
                        {testimonials?.map((testimonial, i) => (
                            <div key={testimonial.id} className={`w-3 h-3 bg-[#7FC241] ${i === index ? '' : 'opacity-30'} rounded-full mr-1`}></div>
                        ))}
                    </div>
                </div>
            </div> : null}
        </div>
    )
}

export default QuizLoader
